import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AmazonPayComponent} from './components/amazon-pay/amazon-pay.component';
import { AmazonPayButtonComponent } from './components/amazon-pay-button/amazon-pay-button.component';
import { AmazonPayAddressBookComponent } from './components/amazon-pay-address-book/amazon-pay-address-book.component';
import { AmazonPayWalletComponent } from './components/amazon-pay-wallet/amazon-pay-wallet.component';
import { AmazonPayConsentComponent } from './components/amazon-pay-consent/amazon-pay-consent.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AmazonPayComponent,
    AmazonPayButtonComponent,
    AmazonPayAddressBookComponent,
    AmazonPayWalletComponent,
    AmazonPayConsentComponent
  ],
  exports: [
    AmazonPayComponent
  ]
})
export class AmazonPayModule {
}
